import { LoadingRegion } from "./loading-region";
import { SkeletonBlock, SkeletonLine } from "./skeleton-primitives";

/** Brief lazy-route flash outside `AppLayout` (auth pages, onboarding, etc.). */
export function FullPagePublicRouteSkeleton() {
  return (
    <LoadingRegion busy labelKey="common.loadingRoute" className="flex min-h-screen flex-col items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md space-y-4">
        <SkeletonBlock className="mx-auto h-12 w-40" />
        <SkeletonBlock className="h-48 w-full" />
        <SkeletonLine className="w-3/4" />
        <SkeletonLine className="w-1/2" />
      </div>
    </LoadingRegion>
  );
}

/**
 * Mimics collapsed sidebar + header + main content while auth or in-app route chunk loads.
 */
export function AppShellRouteSkeleton() {
  return (
    <LoadingRegion busy labelKey="common.loadingRoute" className="flex min-h-screen w-full bg-background">
      <div className="flex w-16 shrink-0 flex-col gap-3 border-r border-border/50 px-2 py-4">
        <SkeletonBlock className="mx-auto size-9 rounded-lg" />
        <SkeletonBlock className="mx-auto h-8 w-8 rounded-md" />
        <SkeletonBlock className="mx-auto h-8 w-8 rounded-md" />
        <SkeletonBlock className="mx-auto h-8 w-8 rounded-md" />
        <div className="flex-1" />
        <SkeletonBlock className="mx-auto size-8 rounded-full" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex h-14 shrink-0 items-center gap-3 border-b border-border/50 px-6">
          <SkeletonLine className="h-5 w-40" />
          <div className="flex-1" />
          <SkeletonBlock className="h-9 w-24 rounded-lg" />
        </div>
        <div className="flex-1 space-y-4 px-6 pt-10 pb-6">
          <SkeletonLine className="h-6 w-56" />
          <SkeletonBlock className="h-40 w-full max-w-3xl" />
          <SkeletonLine className="h-4 w-full max-w-2xl" />
          <SkeletonLine className="h-4 w-full max-w-xl" />
          <SkeletonLine className="h-4 w-2/3 max-w-lg" />
        </div>
      </div>
    </LoadingRegion>
  );
}

/** In-layout main area only (sidebar + header already visible). */
export function MainOutletSkeleton() {
  return (
    <LoadingRegion busy labelKey="common.loadingRoute" className="flex min-h-[40vh] w-full flex-col gap-4 py-6">
      <SkeletonLine className="h-6 w-48" />
      <SkeletonBlock className="min-h-[200px] w-full max-w-4xl rounded-2xl border border-border/40" />
      <div className="flex gap-3">
        <SkeletonLine className="h-4 w-32" />
        <SkeletonLine className="h-4 w-24" />
      </div>
    </LoadingRegion>
  );
}
